import { render } from "./groupHome.vue?vue&type=template&id=7c98be7b&scoped=true"
import script from "./groupHome.vue?vue&type=script&lang=js"
export * from "./groupHome.vue?vue&type=script&lang=js"

import "./groupHome.vue?vue&type=style&index=0&id=7c98be7b&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c98be7b"]])

export default __exports__